import { Injectable } from "@angular/core";
import { HttpService } from "./utils/http.service";
import { IOrendaChemicalHistoryModel, IStructureTypeModel, DosageRecommendationRequestModel, DosageRecommendationResponse } from "@models";

@Injectable({ providedIn: 'root' })  //This automatically registers it globally

export class OrendaService {
    constructor(private readonly httpService: HttpService) { }

    getOrendaChemicalHistory(customerId: number): Promise<IOrendaChemicalHistoryModel[]> {
        return this.httpService.get("/orenda/GetOrendaChemicalHistory", { customerId });
    }

    addOrendaChemicalHistory(orendaChemicalHistory: IOrendaChemicalHistoryModel) {
        return this.httpService.post("/orenda/AddOrendaChemicalHistory", orendaChemicalHistory);
    }

    getCalculateLSI(url: string): Promise<any> {
        return this.httpService.get(url);
    }

    getDosageRecommendationService(requestModel: DosageRecommendationRequestModel): Promise<DosageRecommendationResponse> {
        return this.httpService.get("/orenda/DosageRecommendations", requestModel);
    }

    async deleteOrendaChemicalHistory(id: number): Promise<any> {
        return await this.httpService.post("/orenda/DeleteOrendaChemicalHistory", id);
    }

    updateOrendaDesiredSettings(
        customerId: number,
        jobId: number,
        structureId: number,
        model: IOrendaChemicalHistoryModel
    ): Promise<any> {
        return this.httpService.post(
            `/orenda/UpdateOrendaDesiredSettings?customerId=${customerId}&jobId=${jobId}&structureId=${structureId}`,
            model
        );
    }
}